import {useNavigate} from "react-router-dom";
import {pathTo} from "@/constants/routes";
import GamesListPage from "./GamesListPage";
import type {Game} from "./games.types";

const GamesListRoute = () => {
  const navigate = useNavigate();
  const handleSelect = (game: Game) => {
    if (!game.provider) return;
    navigate(pathTo.gameById(game.provider, game.id));
  };

  return (
    <main className="min-h-screen w-full bg-[var(--color-bg)]">
      <GamesListPage onGameSelect={handleSelect} />
    </main>
  );
};

export default GamesListRoute;
